import { UserMultiple } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Сотрудники и приглашения (ПОРТ-12…20; матрица 2.2: OWNER — изменение, MED_DIRECTOR — врачи, OPS_DIRECTOR и HR — чтение).
 * Вложенный адрес /staff/join-requests — ссылка из уведомления о запросе на присоединение.
 */
export const section = defineSection({
  id: 'org.staff',
  area: 'clinic',
  path: 'staff/*',
  roles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'HR'],
  icon: UserMultiple,
  titleKey: 'staff:title',
  namespaces: ['portal'],
  navGroup: 'manage',
  order: 20,
  tabGroup: 'clinic',
  load: () => import('./StaffPage'),
});
